/**
 * The `tomtom.com/daas-*` catalog annotation keys.
 *
 * These are a contract with entities already deployed: the DaaS scaffolder
 * templates write them into every generated `catalog-info.yaml`, and three
 * separate packages read them back - `daas-frontend` (the ArgoCD status cards
 * and the explorer row actions), `kaap-frontend` (the tenant dependencies
 * card) and the `tomtom:*` DaaS scaffolder actions in `packages/backend`.
 * They live here so that there is exactly one spelling of each key: renaming
 * one is a migration of the deployed entities, never a refactor.
 */

/** The DaaS project id, as the project template generated it. */
export const ANNOTATION_DAAS_PROJECT_ID = 'tomtom.com/daas-project-id';

/** The ArgoCD project segment of every DaaS status path. */
export const ANNOTATION_DAAS_PROJECT_NAME = 'tomtom.com/daas-project-name';

/** The `-<hash>` suffix ArgoCD appends to a project's children. */
export const ANNOTATION_DAAS_PROJECT_HASH = 'tomtom.com/daas-project-hash';

/** An application's own ArgoCD name, without the project hash. */
export const ANNOTATION_DAAS_APPLICATION_NAME =
  'tomtom.com/daas-application-name';

/** An application set's own ArgoCD name, without the project hash. */
export const ANNOTATION_DAAS_APPLICATION_SET_NAME =
  'tomtom.com/daas-application-set-name';

/** Deep link into the ArgoCD UI for this entity. Untrusted: sanitise before use. */
export const ANNOTATION_DAAS_ARGOCD_URL = 'tomtom.com/daas-argocd-url';

/** The entity's folder in the DaaS GitOps repository. */
export const ANNOTATION_DAAS_REPO_FOLDER = 'tomtom.com/daas-repo-folder';

/** `'true'` on a `kubernetes-cluster` Resource DaaS is allowed to deploy to. */
export const ANNOTATION_DAAS_AUTHORIZED = 'tomtom.com/daas-authorized';
